module.exports = __webpack_public_path__ + "img/img_qipa.013f865f.png";